// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"5d247aa6","211":"d8bf575b"}[chunkId] + ".chunk.js";
};